import { Component } from '@angular/core';

@Component({
  selector: 'mps-app-footer',
  templateUrl: './mps-footer.component.html',
  styleUrls: ['./mps-footer.component.scss'],
})
export class MpsFooterComponent {
  constructor() { }

  get year() {
    return new Date().getFullYear();
  }
}
